import { Button } from 'components'

import FormRow, { FormRowProps } from './FormRow'
import styles from './FormRow.module.scss'

interface ActionFormRowProps extends FormRowProps {
  actionTitle: string
  onClick: () => void
}

const ActionFormRow = ({
  actionTitle,
  children,
  onClick,
  ...otherFormRowProps
}: ActionFormRowProps) => (
  <FormRow {...otherFormRowProps}>
    <>
      <Button className={styles.action} onClick={onClick} variant="secondary">
        {actionTitle}
      </Button>
      {children}
    </>
  </FormRow>
)

export default ActionFormRow
